import { render, staticRenderFns } from "./metatemplate.vue?vue&type=template&id=10d83728&scoped=true&"
import script from "./metatemplate.vue?vue&type=script&lang=js&"
export * from "./metatemplate.vue?vue&type=script&lang=js&"
import style0 from "./metatemplate.vue?vue&type=style&index=0&id=10d83728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d83728",
  null
  
)

export default component.exports